var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731121465311,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 48758,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700.7 658.7c-20 0-40.4-3.1-60.9-11.4l-7.6-3.1C547 609.5 490.7 586.5 407 625c-135.7 62.3-300 3.2-306.9 0.7-12.2-4.5-18.5-18-14-30.3 4.5-12.2 18-18.5 30.3-14 1.5 0.6 153.2 54.8 271 0.7 102.3-47 173.1-18.1 262.7 18.4l7.6 3.1c38.7 15.7 79.4 5.3 122.5-5.7 46.9-12 95.5-24.5 145.1-4 12 5 17.8 18.8 12.8 30.8s-18.7 17.8-30.8 12.8c-35.1-14.5-74.1-4.5-115.4 6.1-28.5 7.2-59.3 15.1-91.2 15.1z",
    fill: "#59285E",
    "p-id": 48759
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M799.7 434.1H237.5c-33.6 0-60.9-27.3-60.9-60.9 0-157.4 127.6-285 285-285h114c157.4 0 285 127.6 285 285 0 33.7-27.2 60.9-60.9 60.9z",
    fill: "#FFAD47",
    "p-id": 48760
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M799.7 457.7H237.5c-46.6 0-84.5-37.9-84.5-84.5C153 203 291.4 64.6 461.6 64.6h114c170.2 0 308.6 138.4 308.6 308.6 0 46.6-37.9 84.5-84.5 84.5zM461.6 111.8c-144.1 0-261.4 117.3-261.4 261.4 0 20.6 16.7 37.3 37.3 37.3h562.2c20.6 0 37.3-16.7 37.3-37.3 0-144.1-117.3-261.4-261.4-261.4h-114z",
    fill: "#59285E",
    "p-id": 48761
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M294.8 305.4h50.1",
    fill: "#FFD45F",
    "p-id": 48762
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344.9 323.1h-50.1c-9.8 0-17.7-7.9-17.7-17.7 0-9.8 7.9-17.7 17.7-17.7h50.1c9.8 0 17.7 7.9 17.7 17.7 0 9.8-8 17.7-17.7 17.7z",
    fill: "#59285E",
    "p-id": 48763
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M439.2 237.6h41.3",
    fill: "#FFD45F",
    "p-id": 48764
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M480.5 255.3h-41.3c-9.8 0-17.7-7.9-17.7-17.7s7.9-17.7 17.7-17.7h41.3c9.8 0 17.7 7.9 17.7 17.7s-7.9 17.7-17.7 17.7z",
    fill: "#59285E",
    "p-id": 48765
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M589.6 308.4h26.5",
    fill: "#FFD45F",
    "p-id": 48766
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M616.1 326.1h-26.5c-9.8 0-17.7-7.9-17.7-17.7s7.9-17.7 17.7-17.7h26.5c9.8 0 17.7 7.9 17.7 17.7s-7.9 17.7-17.7 17.7z",
    fill: "#59285E",
    "p-id": 48767
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M681 246.5h32.4",
    fill: "#FFD45F",
    "p-id": 48768
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M713.4 264.2H681c-9.8 0-17.7-7.9-17.7-17.7 0-9.8 7.9-17.7 17.7-17.7h32.4c9.8 0 17.7 7.9 17.7 17.7 0 9.7-7.9 17.7-17.7 17.7z",
    fill: "#59285E",
    "p-id": 48769
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M220.3 789.9H817c24.1 0 43.6 19.5 43.6 43.6 0 56.2-45.5 101.7-101.7 101.7H278.4c-56.2 0-101.7-45.5-101.7-101.7-0.1-24.1 19.5-43.6 43.6-43.6z",
    fill: "#FFAD47",
    "p-id": 48770
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M758.9 958.9H278.4c-69.1 0-125.3-56.2-125.3-125.3 0-37.1 30.2-67.2 67.2-67.2H817c37.1 0 67.2 30.2 67.2 67.2 0 69.1-56.2 125.3-125.3 125.3zM220.3 813.5c-11.1 0-20.1 9-20.1 20.1 0 43.1 35.1 78.2 78.2 78.2h480.5c43.1 0 78.2-35.1 78.2-78.2 0-11.1-9-20.1-20.1-20.1H220.3z",
    fill: "#59285E",
    "p-id": 48771
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M814.1 573.7H223.2c-24.4 0-44.2-19.8-44.2-44.2 0-24.4 19.8-44.2 44.2-44.2h590.9c24.4 0 44.2 19.8 44.2 44.2 0 24.4-19.8 44.2-44.2 44.2z",
    fill: "#86D172",
    "p-id": 48772
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M814.1 597.3H223.2c-37.4 0-67.8-30.4-67.8-67.8s30.4-67.8 67.8-67.8h590.9c37.4 0 67.8 30.4 67.8 67.8s-30.4 67.8-67.8 67.8z m-590.9-88.4c-11.4 0-20.6 9.3-20.6 20.6 0 11.4 9.3 20.6 20.6 20.6h590.9c11.4 0 20.6-9.3 20.6-20.6 0-11.4-9.3-20.6-20.6-20.6H223.2z",
    fill: "#59285E",
    "p-id": 48773
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M825.9 732.9H211.4c-17.9 0-32.4-14.5-32.4-32.4s14.5-32.4 32.4-32.4h614.4c17.9 0 32.4 14.5 32.4 32.4 0.1 17.9-14.4 32.4-32.3 32.4z",
    fill: "#FD3426",
    "p-id": 48774
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M825.9 756.5H211.4c-30.9 0-56-25.1-56-56s25.1-56 56-56h614.4c30.9 0 56 25.1 56 56s-25 56-55.9 56z m-614.5-64.9c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h614.4c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9H211.4z",
    fill: "#59285E",
    "p-id": 48775,
    "data-spm-anchor-id": "a313x.search_index.0.i7.2d0b3a81hDyYy1",
    className: "selected"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M582.5 674.7l94.4 128.7 107.3-128.7z",
    fill: "#FFD45F",
    "p-id": 48776
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M676.9 827h-0.7c-7.2-0.2-14-3.8-18.3-9.6l-94.4-128.7c-5.3-7.2-6-16.7-2-24.6 4-7.9 12.2-12.9 21-12.9h201.6c9.1 0 17.5 5.3 21.4 13.6 3.9 8.3 2.6 18.1-3.2 25.1L695 818.5c-4.5 5.4-11.1 8.5-18.1 8.5z m-47.8-128.7l49 66.9 55.7-66.9H629.1z",
    fill: "#59285E",
    "p-id": 48777
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.2aba1269.svg";
export { ForwardRef as ReactComponent };